import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslationService } from '../services/translation.service';

/**
 * Pipes are pure meaning it will only fire off when there is direct value change.
 * Adding language value make the pipe value fire off again after rendering to run translation.
 */
@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {

	constructor(
		private translationService: TranslationService,
	) {
	}

	// Language is placeholder to fire off again
	public transform(value: string, jsonKey: string, language: string, isHtml: boolean): Observable<string> {
		return this.translationService.translate(value, jsonKey, isHtml);
	}
}
